import { render, staticRenderFns } from "./MemberRegistration.vue?vue&type=template&id=06751ae6&scoped=true&lang=pug&"
import script from "./MemberRegistration.vue?vue&type=script&lang=js&"
export * from "./MemberRegistration.vue?vue&type=script&lang=js&"
import style0 from "./MemberRegistration.vue?vue&type=style&index=0&id=06751ae6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06751ae6",
  null
  
)

export default component.exports